export default __webpack_public_path__ + "static/media/doc-2.5dad7d6a.jpg";